import React, { useEffect, useState, useRef } from 'react';
import { Grid, Paper, TextField, Typography, Button } from '@material-ui/core'
import { useDispatch, useSelector } from "react-redux";
import { ExitButton } from "../../../utils/etc";
import { flightTextHistory, individualTextHistory } from "../../../store/dcs"
import { SelectWithLabel } from "../../../utils/selectWithLabel";
import { textPax } from "../../../store/dcs";
import { Send} from '@material-ui/icons';
import moment from 'moment';
import _ from 'lodash';

const TextHistoryModal = (props) => {
  const modalClasses = props.modalClasses
  const flight = props.flight
  const closeModal = props.closeModal
  const date = props.date;
  const history = useSelector(state => state.entities.dcs.history)
  const textSent = useSelector(state => state.entities.dcs.sendText)
  const [paxList, setpaxList] = useState('default')
  const [message, setMessage] = useState('')

  const dispatch = useDispatch();
  
  useEffect(() => {
    dispatch(flightTextHistory(date, flight.FlightNumber))
  }, []);

  
  // NOTE Used for scrolling to bottom of chat window (showing newest messages first)
  const messagesEndRef = useRef(null)
  const scrollToBottom = () => {
    if (!messagesEndRef.current) return;
    messagesEndRef.current.scrollIntoView({ behavior: "smooth" })
  }
  useEffect(() => {
    scrollToBottom()
  }, [history]);


  const handlePaxList = (data) => {
    if (data === 'default') {
      dispatch(flightTextHistory(date, flight.FlightNumber))
    } else {
      dispatch(individualTextHistory(data.phone))
      setpaxList(data)
    }
  }

  if (textSent === 'Success') {
    if (paxList === 'default') {
      dispatch(flightTextHistory(date, flight.FlightNumber))
      setMessage('');
    } else {
      dispatch(individualTextHistory(paxList.phone))
      setMessage('');
      setpaxList(paxList)
    }
  }

  const handleSend = () => {
    if (paxList !== 'default' && message) {
      // NOTE // removing xml reserved characters
      // let formattedMsg = _.cloneDeep(message).split(',').join('').split('<').join('').split('>').join('').split('&').join('').split('\'').join('').split('\"').join('')
      dispatch(textPax(message, [paxList]))
    }
  }

  // Removes pax w/o phone numbers
  let paxChoices = flight.passengers
    .filter((pax) => pax.phone)
    .map((pax) => {
      return {label: `${pax.FirstName} ${pax.LastName} (${pax.PNRRefNo})`, value: pax}
  })

  paxChoices.unshift({label: 'All History', value: 'default'})
  let dateChecker = {};

  return (
    <Grid container justify="center" alignContent="center" style={{marginTop: '10%'}}>
      <Paper className={modalClasses.paper}>
        <Grid id="history-modal-header" container item xs={12} justify="center" className={modalClasses.modalHeader}>
          <Grid item xs={2} lg={2}></Grid>
          <Grid container justifyContent="center" item xs={8} lg={8}>
            <h5 style={{margin: "0px", paddingTop: "12px"}}>
              {`${flight.FlightNumber} SMS History`}
            </h5>
          </Grid>
          <Grid item xs={1} lg={1}></Grid>
          <Grid container alignContent="flex-start" justifyContent="flex-end" style={{paddingRight: '8px'}} item xs={1}>
            <ExitButton exit={closeModal} />
          </Grid>
        </Grid>
        <Grid id="history-body" justifyContent="center" container item xs={12}>
          <Grid item xs={12} className={modalClasses.center}>
            <SelectWithLabel defaultVal={paxList} handleChange={(e) => {handlePaxList(e.target.value)}} inputLabel={'Passengers'} items={paxChoices} customStyle={{width: '33%'}}/>
          </Grid>
          <Grid container className={modalClasses.messageContainer}>
            {!!history.length ? history.map((item) => {
              // NOTE // Used to display text messages sent / received on different days
              let newestDate = moment(new Date(item.timestamp)).format('DD MMM YYYY');
              !dateChecker[newestDate] ? dateChecker[newestDate] = 1 : dateChecker[newestDate]++;
              return (<Grid container justifyContent="center"> 
                {item.outbound ? 
                  <Grid container>
                    <Grid item xs={12} className={modalClasses.centerDates}><Typography>{dateChecker[newestDate] === 1 ? newestDate : ``}</Typography></Grid>
                    <Grid item xs={4} className={modalClasses.outboundMessageTimes}><Typography>{moment(item.timestamp).format('h:mmA')}</Typography></Grid>
                    <Grid item xs={8} className={modalClasses.outboundPadding}>
                      <Typography className={modalClasses.outbound}>{item.body}</Typography>
                    </Grid>
                  </Grid> : 
                  <Grid container>
                    <Grid item xs={12} className={modalClasses.centerDates}><Typography>{dateChecker[newestDate] === 1 ? newestDate : ``}</Typography></Grid>
                    <Grid item xs={8} className={modalClasses.inboundPadding}>
                      <Typography className={modalClasses.inbound}>{item.body}</Typography>
                    </Grid>
                    <Grid item xs={4} className={modalClasses.inboundMessageTimes}><Typography>{moment(item.timestamp).format('h:mmA')}</Typography></Grid>
                  </Grid>
                }
                <div ref={messagesEndRef} />
              </Grid>)
            }) : ``}
          </Grid>
          <Grid container>
            <Grid item xs={12} className={modalClasses.absoluteCenter} >
              {/* FIXME which textField?? */}
              <TextField 
                label="Message"
                multiline
                rows={3}
                className={modalClasses.textHistTextField}
                value={message}
                onChange={(e) => {setMessage(e.target.value)}}
                variant="filled"
                style={{width: '100%', height: 'inherit'}}
              />
            </Grid>
            <Grid item xs={12} className={modalClasses.outboundMessageTimes}> 
              {/* className={classes.button} */}
              {textSent === null ? 
                message.length  && paxList !== 'default' ? 
                <Button onClick={() => {handleSend()}} variant="contained" color="primary" endIcon={<Send />}>Send</Button> : 
                <Button disabled variant="contained" color="primary" endIcon={<Send />}>Send</Button> : 
              <Button disabled>Sending...</Button>
              }
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  )
};

export default TextHistoryModal;